import { gql } from '@apollo/client'

export const CREATE_FEATURE = gql`
  mutation createFeature($input: CreateFeatureInput!) {
    data: createFeature(input: $input) {
      id
    }
  }
`
